var map = {
	"./valance-french.svg": "5706",
	"./valance-roman.svg": "65ab",
	"./valance-scallop-short.svg": "b146",
	"./valance-scallop.svg": "0338",
	"./valance-standard.svg": "6b1e",
	"./valance-trojan.svg": "78a4",
	"./valance-vintage-scallop.svg": "308a",
	"./valance-wave-scallop-short.svg": "7a3e",
	"./valance-wave-scallop.svg": "5f00",
	"./valance-whale.svg": "1994"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e266";